var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getPage)?_c('div',{attrs:{"id":"page"}},[_c('h1',[_vm._v(_vm._s(_vm.getPage.title))]),_c('div',{staticClass:"border-top pt-3"},[_c('b-container',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.getPage.body)}})])],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }